<template>
  <section>
    <m-img src="@/v2/mobile/assets/image/h_60.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>